"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default((theme) => ({
    paper: {
        width: '600px',
        height: 'fit-content',
        minHeight: 26,
    },
    paperItem: {
        minHeight: 26,
        lineHeight: '26px',
        padding: '0 10px',
    },
    popper: {
        width: '500px',
        zIndex: 1500,
    },
    icon: {
        marginRight: '2pt',
        padding: 1,
    },
    iconOpened: {
        transform: 'rotate(180deg)',
    },
    wrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.editing,
    },
    wrapperDisabled: {
        backgroundColor: 'inherit',
    },
    chips: {
        marginTop: 3,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    chipsWrapper: {
        flex: 1,
        display: 'flex',
    },
    chip: {
        height: 20,
        margin: '0 2px 2px 2px',
    },
    input: {
        flexGrow: 1,
        flexShrink: 1,
        minWidth: '30%',
    },
    delimiter: {
        display: 'inline',
        marginLeft: 10,
    },
    disabledComponent: {
        lineHeight: '22px',
        height: 22,
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    builder: {
        width: '100%',
        minHeight: 338,
    },
    builderActions: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        height: 38,
        width: '100%',
        boxSizing: 'border-box',
        verticalAlign: 'top',
        display: 'flex',
        padding: '0 12px',
        '& svg': {
            cursor: 'pointer',
            width: 20,
            height: 20,
            padding: '2pt',
        },
    },
    buttonGroup: {
        display: 'flex',
        marginBottom: 8,
    },
    collapseButton: {
        padding: '2pt',
        height: 23,
        minWidth: 23,
        marginRight: 15,
        background: 'transparent',
    },
    actionButton: {
        padding: '2pt',
        height: 23,
        minWidth: 23,
        marginRight: 5,
        background: 'transparent',
        '& svg': {
            fontSize: '1rem',
        },
    },
    item: {
        padding: '2pt 0',
        alignItems: 'center',
        display: 'flex',
        borderBottom: '1px solid #efefef',
        fontFamily: theme.typography.fontFamily,
    },
    itemBody: {
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        background: 'rgb(255 255 255 / 66%)',
    },
    itemBadgeRoot: {
        marginLeft: 30,
        fontWeight: 300,
        verticalAlign: 'super',
    },
    itemBadgeContent: {
        fontSize: 10,
        padding: 3,
        height: 'auto',
    },
    itemSelected: {
        backgroundColor: theme.palette.grey[300],
    },
    itemFocused: {
        backgroundColor: theme.palette.highlight,
    },
    noMatch: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 100,
        margin: '15px 0',
    },
}));
//# sourceMappingURL=tree-styles.js.map